import React from "react";
import PropTypes from "prop-types";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import TableSortLabel from "@mui/material/TableSortLabel";

const stickySx = {
  position: "sticky",
  top: 0,
  background: "#fff",
  zIndex: 10,
};

const EnhancedTableHead = props => {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    headRows,
    selectAll,
    allowOrder,
  } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {selectAll ? (
          <TableCell sx={stickySx} padding="checkbox" style={{ minWidth: "125px", maxWidth: "125px" }}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
              slotProps={{ input: { "aria-label": "Select all desserts" } }}
            />
          </TableCell>
        ) : (
          <TableCell sx={stickySx} padding="checkbox" style={{ minWidth: "125px", maxWidth: "125px" }} />
        )}
        {allowOrder
          ? headRows.map(row => (
              <TableCell
                sx={stickySx}
                key={row.id}
                align={row.numeric ? "right" : "left"}
                padding={row.disablePadding ? "none" : "normal"}
                sortDirection={orderBy === row.id ? order : false}
              >
                <TableSortLabel active={orderBy === row.id} direction={order} onClick={createSortHandler(row.id)}>
                  {row.label}
                </TableSortLabel>
              </TableCell>
            ))
          : headRows.map(row => (
              <TableCell
                sx={stickySx}
                key={row.id}
                align={row.numeric ? "right" : "left"}
                padding={row.disablePadding ? "none" : "normal"}
                sortDirection={orderBy === row.id ? order : false}
              >
                {row.label}
              </TableCell>
            ))}
      </TableRow>
      <TableRow style={{ height: "1px", borderBottom: "1px solid rgba(224, 224, 224, 1)" }} />
    </TableHead>
  );
};

EnhancedTableHead.defaultProps = {
  selectAll: true,
  allowOrder: true,
};

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headRows: PropTypes.array.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  selectAll: PropTypes.bool,
  allowOrder: PropTypes.bool,
};

export default EnhancedTableHead;
